import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/navbar";
import Footer from "../components/footer";

const MainLayout = ({ currentLang, changeLang }) => {
  return (
    <div className="d-flex flex-column min-vh-100">
      <Navbar currentLang={currentLang} changeLang={changeLang} />

      <main className="flex-grow-1">
        <Outlet /> {/* Ovdje će se ubaciti Home, Services, About, Contact */}
      </main>

      <Footer />
    </div>
  );
};

export default MainLayout;